import { render } from "./customerhistory.vue?vue&type=template&id=40b86682"
import script from "./customerhistory.vue?vue&type=script&lang=js"
export * from "./customerhistory.vue?vue&type=script&lang=js"

import "./customerhistory.vue?vue&type=style&index=0&id=40b86682&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__